import { utilsQuery } from "@app/common";

const define = utilsQuery.defineQueryKeyCreator("account");

export const QueryKeys = {
    Account: define("account"),
    Accounts: define("accounts"),
} as const;
